import { create } from "apisauce";
import { decodeCookie, logOut } from "../utils/decodeCookie";
import toast from "react-hot-toast";

// Extract the domain from the current window location
const extractDomain = () => {
  const domain = /:\/\/([^\/]+)/.exec(window.location.href)[1];
  if (domain !== "members.tripmerchant.com") {
    const parts = domain.split(".");
    const subDomain = parts[0] === "www" ? parts[1] : parts[0];
    if (subDomain && subDomain !== "tripmerchant" && subDomain !== "localhost:3001") {
      return subDomain;
    }
  }
  return "trip"; // Default domain
};

const domain = extractDomain();
export const config = async () => {
     let token = null 
  if(domain == 'tripbuilder'){
     token = decodeCookie('tripbuilder').slice(1);
  }else {
     token = decodeCookie(
      process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_TOKEN_KEY
    ).slice(1);
    
  }



  return {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
};

export const multiPartConfig = async () => {
  let token = null 
  if(domain == 'tripbuilder'){
     token = decodeCookie('tripbuilder').slice(1);
  }else {
     token = decodeCookie(
      process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_TOKEN_KEY
    ).slice(1);
    
  }
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "multipart/form-data/json",
    },
  };
};

export const apiClient = create({
  baseURL: process.env.REACT_APP_TRIP_MERCHANT_API_KEY,
});

const responseMonitor = (response) => {
  if (response.status === 422) {
    return;
  } else if (
    response.status === 401 || response.status === 403 || (domain == 'tripbuilder'? !decodeCookie('tripbuilder').slice(1)
    : !decodeCookie(
      process.env.REACT_APP_TRIP_MERCHANT_ORGANIZATION_TOKEN_KEY
    ).slice(1))
    
  ) {

     const pathname = window.location.pathname
    if(!decodeCookie('adminOrSupplier').slice(1) || !pathname.includes('/supplier-trip-detail')){
        window.postMessage("NotAuthorized");
        logOut(pathname);
        toast.dismiss();
        toast.error("Session Expired. Login Again");
    }

  }
};

apiClient.addMonitor(responseMonitor);
